import {MigrationRuns} from '~/features/Migrations';

export const MigrationRunsScene = () => {
  return <MigrationRuns />;
};
